import React, { useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Modal from '../../components/Modal'
import { Input, Select } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createActivity, updateActivity } from '../../actions/activity'
import styles from './styles.module.scss'
import Confirmation from '../../components/Confirmation/Confirmation'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле'),
  basic_activity: Yup.string().required('обязательное поле'),
  cpa: Yup.number().required('обязательное поле'),
})

export default function ActivityModal({ data, closeModal }) {
  const dispatch = useDispatch()

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])
  const { basicActivity } = useSelector(state => state.common)

  const addMode = !data?.id

  const handleCreateEntity = async (values) => {
    await dispatch(createActivity(values))
    closeModal()
  }

  const handleUpdateEntity = async (values) => {
    const { id, ...payload } = values
    await dispatch(updateActivity(id, payload))
    closeModal()
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit
  } = useFormik({
    initialValues: addMode ? { name: '', basic_activity: '', cpa: '' } : data,
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: validationSchema,
    onSubmit: addMode ? handleCreateEntity : handleUpdateEntity
  })

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const renderOptions = ({ name, id }) => <option key={id} value={id}>{name}</option>

  return (
    <Modal open={!!data} onClose={handleClose} closeOnOverlayClick={true} closeOnEsc={true}>
      <div className={styles.modalMain}>
        <div className={styles.tabWrapper}>
          <div className={styles.inputsRow}>
            <Input
              label='Активность'
              name='name'
              value={values.name}
              error={error('name')}
              onChange={handleChange}
              style={{ width: '300px' }}
            />
          </div>
          <div className={styles.inputsRow}>
            <Select
              label='Вид активности'
              name='basic_activity'
              value={values.basic_activity}
              onChange={handleChange}
              error={error('basic_activity')}
            >
              <option value=''>Не выбрано</option>
              {basicActivity?.map(renderOptions)}
            </Select>
          </div>
          <div className={styles.inputsColumn}>
            <Input
              label='КФА'
              name='cpa'
              value={values.cpa}
              error={error('cpa')}
              onChange={handleChange}
              style={{ width: '300px' }}
              type='number'
            />
          </div>
        </div>
      </div>
      <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}
